import { Grid, IconButton, Tooltip } from "@material-ui/core";

import BrokenImageIcon from "@material-ui/icons/BrokenImage";
import DeleteIcon from "@material-ui/icons/Delete";
import { Fragment } from "react";
import InfoIcon from "@material-ui/icons/Info";
import InsertPhotoIcon from "@material-ui/icons/InsertPhoto";
import MeditocActions from "../../../utils/MeditocActions";
import MeditocModal from "../../../utils/MeditocModal";
import { useColaborador } from "../../../../context/ColaboradorContext";
import { useLogin } from "../../../../context/LoginContext";

export default function FotoColaborador() {
    const {
        colaboradorSeleccionado,
        modalOpenFotoColaborador,
        fotoColaborador,
        handleOpenFotoColaborador,
        handleClickCambiarFoto,
        handleClickEliminarFoto,
    } = useColaborador();
    const { usuarioPermisos } = useLogin();

    const permisos = usuarioPermisos["2"].Submodulos["1"];

    return (
        <MeditocModal
            title="Foto de colaborador"
            open={modalOpenFotoColaborador}
            setopen={handleOpenFotoColaborador}
            okmessage="Cerrar vista de foto"
            size="small"
            hidecancel
        >
            <MeditocActions title={colaboradorSeleccionado.sNombreDirectorio}>
                {permisos.Botones["8"] !== undefined && ( //Agregar o cambiar foto
                    <Fragment>
                        <Tooltip
                            arrow
                            title="Las proporciones de la imagen permitidas se encuentran entre 9:12 (ancho:altura) y 9:16 (ancho:altura). Ejemplo: 600px(ancho) por 900px(altura)."
                        >
                            <IconButton>
                                <InfoIcon className="color-1" />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title={permisos.Botones["8"].Nombre} arrow>
                            <IconButton onClick={handleClickCambiarFoto}>
                                <InsertPhotoIcon className="color-1" />
                            </IconButton>
                        </Tooltip>
                    </Fragment>
                )}
                {permisos.Botones["9"] !== undefined && ( //Eliminar foto
                    <Tooltip title={permisos.Botones["9"].Nombre} arrow>
                        <IconButton onClick={handleClickEliminarFoto}>
                            <DeleteIcon className="color-1" />
                        </IconButton>
                    </Tooltip>
                )}
            </MeditocActions>
            <Grid container spacing={3}>
                <Grid item xs={12} className="center">
                    {fotoColaborador !== "" ? (
                        <img
                            alt="FotoColaborador"
                            src={`data:image/png;base64,${fotoColaborador}`}
                            className="foto-colaborador"
                        />
                    ) : (
                        <BrokenImageIcon style={{ fontSize: 180, color: "#e6e6e6" }} />
                    )}
                </Grid>
            </Grid>
        </MeditocModal>
    );
}
